// extracted by mini-css-extract-plugin
export default {"layout":"_5D21bRLf","error":"_5DVlhK8v","login-back":"_5D2XlSXB","intro":"_5D34RdQW","submit":"_5D1f-C-b"};